{
  "plan_details": {
    "frequency": {
      "annually": "Jährlich",
      "monthly": "Monatlich",
      "title": "Zahlen Sie jährlich und sparen Sie 10%"
    },
    "choose_currency": "Wählen Sie Ihre Währung",
    "includes": "Was ist enthalten:",
    "everything_in": "Alles in {{ plan }} plus:",
    "per_user": "pro Benutzer/pro Monat",
    "switch_to": "Wechseln Sie zu {{ plan }}",
    "upgrade_to": "Auf {{ plan }} upgraden",
    "manage_plan": "Plan verwalten",
    "call_us": "Ruf uns an",
    "contact_us": "Kontaktiere uns",
    "title": {
      "part_1": "Wählen Sie den perfekten Plan für Sie und Ihre",
      "part_2": "Mannschaft"
    },
    "subtitle": {
      "part_1": "Vergleichen Sie unsere Tarife und Funktionen auf unserer",
      "part_2": "Seite mit Preisinformationen",
      "part_3": "oder"
    },
    "plans": {
      "professional": {
        "name": "Fachmann",
        "prev_plan": "",
        "features": {
          "1": "Unbegrenzte Tarife für Ihre Veranstaltung",
          "2": "Zugriff auf eine umfangreiche Bibliothek mit Ebenenvorlagen",
          "3": "3D-Modelle zur genauen Visualisierung von Plänen",
          "4": "Attribute zur Erfassung von Daten, einschließlich Terminen und Kosten",
          "5": "Gemeinsamer Arbeitsbereich für dein Team",
          "6": "Anpassbare und flexible Ebenen und Symbole",
          "7": "Analysetools einschließlich Crowd-Capacity-Rechner",
          "8": "Professionelle PDF-Exporte",
          "9": "CAD-Integration und unbegrenzte Updates",
          "10": "Unterstützung beim Onboarding",
          "11": "Unbegrenzte Anzahl an Zuschauern!"
        }
      },
      "premium": {
        "name": "Prämie",
        "prev_plan": "Fachmann",
        "features": {
          "1": "Erfassen und visualisieren Sie Pläne nach Uhrzeit und Datum",
          "2": "Tools für die Zusammenarbeit, z. B. Kommentare, Tagging, Threads",
          "3": "Kombinieren Sie die Pläne verschiedener Benutzer und Teams",
          "4": "Analysieren Sie Mengen und Kosten in Ihrem gesamten Projekt",
          "5": "Export von Geodaten in GIS-Formaten",
          "6": "Dienst zum Importieren von CAD-Daten",
          "7": "Maßgeschneiderter Onboarding-Support",
          "8": "Unbegrenzte Anzahl an Zuschauern!"
        }
      },
      "enterprise": {
        "name": "Unternehmen",
        "prev_plan": "Prämie",
        "features": {
          "1": "Maßgeschneidertes Onboarding und Kontoverwaltung",
          "2": "Visualisieren Sie Pläne mithilfe von Grafiken in Spielequalität",
          "3": "Planen Sie mithilfe von Google 3D-Stadtplänen",
          "4": "Veröffentlichen Sie Markenkarten online",
          "5": "Expertenunterstützung bei der Erstellung von 3D-Modellen, Symbolen und Vorlagen",
          "6": "SSO für zusätzliche Sicherheit",
          "7": "Support rund um die Uhr"
        }
      }
    }
  }
}